export default __webpack_public_path__ + "static/media/features-03-image-02.9dbfd99e.jpg";